import { getAuthState } from '../hooks/useAuth';

let auth = getAuthState()

export const crmSendLeads = async (path:string, crm_name:string, con_token:string, con_funnel?:string, con_stage?:string, cnpj?:string): Promise<any> => {
    try {
        if (!crm_name || !con_token) return false;
        auth = getAuthState()
        const user = auth.username;
        const response = await fetch(`https://f5gkmqm2yh.execute-api.us-east-1.amazonaws.com/prod/crm/leads`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth.idToken
            },
            body: JSON.stringify({
                usuario_cognito: user,
                path:path,
                crm_name:crm_name,
                con_token:con_token,
                con_funnel:con_funnel ?? '',
                con_stage:con_stage ?? '',
                cnpj:cnpj ?? null
            }),
        });

        const data = await response.json()

        return data;

    } catch (error) {
        console.error('Error creating connection:', error);
        return false;
    }
};